import React from "react";
import { Link } from "react-router-dom";

export default function RegionTile({ region, large }) {
  return (
    <Link
      to={`/scopri/regione/${region.slug}`}
      data-testid={`region-tile-${region.slug}`}
      className={`relative block overflow-hidden rounded-sm group ${large ? "aspect-[4/5] md:aspect-[5/6]" : "aspect-[4/3]"}`}
    >
      <img src={region.image} alt={region.name} loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7 text-white">
        <div className="text-[10px] font-bold uppercase tracking-[0.3em] opacity-80">Regione</div>
        <div className={`editorial-heading ${large ? "text-4xl md:text-5xl" : "text-2xl md:text-3xl"} mt-1 leading-none`}>{region.name}</div>
        <div className="text-sm mt-2 opacity-90">{region.tagline}</div>
      </div>
    </Link>
  );
}
